module.exports = __webpack_public_path__ + "static/media/knife_noti.d05471ab.svg";